export default __webpack_public_path__ + "static/brand-5-0a7baa350d2678fbf7fd4ec3164cf689.png";